import React, { Component } from 'react'
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { decode } from 'html-entities';
import Web3 from 'web3'
import './App.css'
import Header from './header.js'
import abi from './abi.js'
import RuneImage from './RuneImage.js'
import runesData from './runesData.js'

export default function App() {
  return (
    <Router>
      <div>
        <Header/>

        <Switch>
          <Route path="/runes">
            <Runes/>
          </Route>
          <Route path="/bind">
            <Bind/>
          </Route>
          <Route path="/">
            <Home/>
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

let web3 = new Web3(window.ethereum);
let contract = new web3.eth.Contract(abi, "0x6f75eDBFb41F94522EED734787fBc78C5688aA1e");

class Home extends Component {
  constructor(props) {
    super(props)
    this.state = { account: '',  runes: Array.from(Array(/*example_num=*/3)), tokenId: 1, minTokenId: 1, maxTokenId: 9700, lootId: 1, mintType: "mint" }

    this.handleTypeChange = this.handleTypeChange.bind(this)
    this.handleTokenIdChange = this.handleTokenIdChange.bind(this);
    this.handleLootIdChange = this.handleLootIdChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.loadBlockchainData();
    Promise.all(
      this.state.runes.map((_) => 
        this.getRunes(Math.floor(Math.random() * 10101) + 1))
    ).then(runes => {
      this.setState({ runes: runes });
    })
  }

  loadBlockchainData() {
    let web3 = new Web3(window.ethereum);
    this.contract = contract;
    web3.eth.getGasPrice().then(result => this.setState({ gas: result }));
    web3.eth.getAccounts().then(accounts => this.setState({ account: accounts[0] }));
    window.ethereum.on('accountsChanged', accounts => {
      console.log(accounts);
      this.setState({ account: accounts[0] });
    });
  }

  async getRunes(tokenId) {
    // if (this.state.contract === undefined) return {}
    let exists_res = await this.contract.methods.exists(tokenId).call();
    let runes_res = await this.contract.methods.runesOf(tokenId).call();
    return {
      id: tokenId,
      runes: JSON.parse(runes_res),
      exists: exists_res
    };
  }

  handleTypeChange(event) {
    if (event.target.value === 'mint') {
      this.setState({minTokenId: 1, maxTokenId: 9700, tokenId: Math.min(9700, Math.max(1, this.state.tokenId))});
    } else if (event.target.value === 'mintWithLoot') {
      this.setState({minTokenId: 9701, maxTokenId: 10000, tokenId: Math.min(10000, Math.max(9701, this.state.tokenId))});
    }
    this.setState({mintType: event.target.value});
  }

  handleTokenIdChange(event) {
    if (event.target.value <= this.state.maxTokenId && event.target.value >= this.state.minTokenId) {
      this.setState({tokenId: event.target.value});
    }
  }

  handleLootIdChange(event) {
    if (event.target.value <= 8000 && event.target.value > 0) {
      this.setState({ lootId: event.target.value })
    }
  }

  handleSubmit(event) {
    if (this.state.mintType === 'mint') {
      contract.methods.mint(this.state.tokenId).send({from: this.state.account, value: 0.03*10**18});
    } else if (this.state.mintType === 'mintWithLoot') {
      contract.methods.mintWithLoot(this.state.tokenId, this.state.lootId).send({from: this.state.account});
    }
    event.preventDefault();
  }

  render() {
    return (
      <div className="feature">
        <form onSubmit={this.handleSubmit}>
          <label>
            <select name="MintType" id="MintType" onChange={this.handleTypeChange} value={this.state.mintType}>
              <option value="mint">Mint</option>
              <option value="mintWithLoot">Mint with Loot</option>
            </select>
          </label>
          <label>
            TokenId: <input type="number" placeholder="tokenId" value={this.state.tokenId} onChange={this.handleTokenIdChange} min={this.state.minTokenId} max={this.state.maxTokenId} />
          </label>
          <label style={{display: this.state.mintType === 'mintWithLoot' ? 'block' : 'none'}}>
            LootId: <input type="number" placeholder="lootId" value={this.state.lootId} onChange={this.handleLootIdChange} min="1" max="8000" />
          </label>
          <label>
            Price: {this.state.mintType === 'mintWithLoot' ? 0 : 0.03} ETH
          </label>
          <input type="submit" value="Buy" />
        </form>
        <span>Example Runes:</span>
        {this.state.runes.map((r, i) => <RuneImage {...r} key={i} />)}
      </div>
    );
  }
}

class Runes extends Component {
  render() {
    const col = ["Rune", "Name", "Meaning"];
    return (
      <table>
        <thead>
          <tr>{col.map((h, i) => <th key={i}>{h}</th>)}</tr>
        </thead>
        <tbody>
          {Object.entries(runesData).map((h, i) => 
            <tr key={i}>
              <td>{decode(h[1][0])}</td>
              <td>{h[0]}</td>
              <td>{h[1][1]}</td>
            </tr>)}
        </tbody>
      </table>
    );
  }
}

class Bind extends Component {
  render() {
    return (
      <div className="feature">
        <h1>Coming Soon!</h1>
      </div>
    );
  }
}